export default function Footer() {
    return (
      <footer className="bg-gradient-to-r from-indigo-700 to-indigo-600 text-white text-center py-6 mt-12">
  
        <div className="max-w-7xl mx-auto">
  
          
          <p className="text-sm mt-1">
            District Administration Bhojpur | Government of Bihar
          </p>
  
          <p className="text-sm mt-1">
            © {new Date().getFullYear()} All Rights Reserved
          </p>
  
        </div>
  
      </footer>
    );
  }